import { AgGridEvent } from 'ag-grid-community';
import { GetMainMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';

export enum LumAgGridEvent {
  COLUMN_TAGS_COLLAPSE = 'lum:column:tagsCollapse',
  COLUMN_TAGS_EXPAND = 'lum:column:tagsExpand',
}

const _LumAgMenuLabelByEvent = {
  [LumAgGridEvent.COLUMN_TAGS_COLLAPSE]: 'Collapse Tags',
  [LumAgGridEvent.COLUMN_TAGS_EXPAND]: 'Expand Tags',
} as const;

export function defineMenuItem<P extends GetMainMenuItemsParams>(
  event :LumAgGridEvent,
  params :P,
  override ?:MenuItemDef,
) :MenuItemDef {
  const name = _LumAgMenuLabelByEvent[event];
  const action = () => {
    params.api.dispatchEvent({
      type: event,
      ...params,
    } as AgGridEvent);
  };

  return { name, action, ...override };
}
